import axios from "axios";
import {
    adapterInfoResponse, adapterChannelResponse, adapterListsResponse,
    adapterListVideo,
} from "./adapters/adapters";

export const getInfoApi = async (search: string) => await axios({
    method: 'GET',
    url: '/youtube/',
    params: {
        search: search,
    }
}).then((response) => {
    // console.log(response.data.items, ' lo que responde la promesa')
    let newResponse = adapterInfoResponse(response);

    return newResponse;
}).catch((err) => console.log(err));


export const getChannelInfoApi = async (channelId: string | undefined) => await axios({
    method: 'GET',
    url: '/channel/',
    params: {
        channelId: channelId,
    }
}).then((response) => {
    // console.log(response.data.items, ' lo que responde al get Channel Id')
    let newResponse = adapterChannelResponse(response);
    return newResponse;
}).catch((err) => console.log(err));


export const getListsInfoApi = async () => await axios({
    method: 'GET',
    url: '/playlists',

}).then((response) => {
    let newResponse = adapterListsResponse(response);
    return newResponse;
}).catch((err) => console.log(err));


export const getListVideoById = async (listId: string | undefined) => await axios({
    method: 'GET',
    url: '/playlist',
    params: {
        listId: listId,
    }  

}).then((response) => {
    let newResponse = adapterListVideo(response);
    return newResponse;
}).catch((err) => console.log(err));